import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Model,
  Opts,
  PagedResponse,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";

export class UserService extends BaseRemoteService {
  public async getAll(params: QueryParams = {}, opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/users/${paramsToSearchString({
      pageSize: 999,
      userType: 1,
    })}`;
    const response = await super.getRequest<PagedResponse<Model>>(url, opts);
    return response.data
      .sort((a, b) => (a.upn > b.upn ? 1 : -1))
      .map((item) => ({
        id: item["id"],
        name: item["fullName"],
        upn: item["upn"],
        teams: item["userTeams"].map((team: Model) => ({
          name: team["name"],
        })),
      }));
  }

  public async getUsers(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/users/${paramsToSearchString({
      pageSize: 999,
    })}`;
    const response = await super.getRequest<PagedResponse<Model>>(url, opts);
    return response.data
      .sort((a, b) => (a.upn > b.upn ? 1 : -1))
      .map((item) => ({ id: item["id"], name: item["upn"] }));
  }
}
